import { alertService } from "client-app-core";
import * as t from "./actionTypes.js";
export { removeDockedCameraAndState } from "orion-components/Dock/Actions/index.js";
import { updateContext } from "orion-components/ContextualData/Actions";

export function startAlertStream() {
	return function (dispatch, getState) {
		const isAlarmWall = getState().application.appId === "alarm-wall-app";
		alertService.streamMyActiveAlerts(isAlarmWall, function (err, response) {
			if (err) {
				console.log(err);
			} else {
				switch (response.type) {
					case "initial-batch": {
						const alerts = response.changes.map((item) => {
							item.new_val.isPriority = true;
							return item.new_val;
						});
						global.isInitialAlertsLoaded = false;
						dispatch(initialAlertsReceived(alerts));
						break;
					}
					case "change-batch": {
						const alerts = response.changes.map((item) => {
							if (item.type === "remove") {
								if (getState().contextualData[item.old_val.id]) {
									dispatch(updateContext(item.old_val.id, item.old_val));
								}
								return item.old_val;
							}
							global.isInitialAlertsLoaded = true;
							item.new_val.isPriority = true;
							if (getState().contextualData[item.new_val.id]) {
								dispatch(updateContext(item.new_val.id, item.new_val));
							}
							return item.new_val;
						});
						dispatch(alertBatchReceived(alerts));
						break;
					}
					default:
				}
			}
		});
	};
}

export const initialAlertsReceived = (alerts) => {
	return {
		alerts,
		type: t.INITIAL_ALERTS_RECEIVED
	};
};

export const alertBatchReceived = (alerts) => {
	return {
		alerts,
		type: t.ALERT_BATCH_RECEIVED
	};
};

export const getArchiveSuccess = (alerts) => {
	return {
		alerts,
		type: t.GET_ALERT_ARCHIVE_SUCCESS
	};
};

export const getArchiveFailed = () => {
	return {
		type: t.GET_ALERT_ARCHIVE_FAILED
	};
};

export const queryArchive = (page) => {
	return (dispatch) => {
		alertService.getArchivedByPage(page, (err, response) => {
			if (err) {
				dispatch(getArchiveFailed());
				console.log(err);
			} else {
				dispatch(getArchiveSuccess(response));
			}
		});
	};
};

export const dumpArchive = () => {
	return {
		type: t.DUMP_ALERT_ARCHIVE
	};
};

export const closeAlert = (alertId) => {
	return {
		alertId,
		type: t.CLOSE_ALERT
	};
};

export const closeBulkAlerts = (alerts, serviceType) => {
	return {
		alerts,
		serviceType,
		type: t.CLOSE_ALERTS
	};
};

export const reopenAlert = (alert) => {
	return {
		alert,
		notificationId: alert.id,
		type: t.REOPEN_ALERT
	};
};

export const reopenBulkAlerts = (alerts) => {
	return {
		alerts,
		alertIds: alerts.map((a) => a.id),
		type: t.REOPEN_ALERTS
	};
};

export const acknowledgeAlerts = (alerts) => {
	return () => {
		alertService.acknowledgeNotifications(alerts, (err) => {
			if (err) {
				console.log(err);
			}
		});
	};
};

export const unAcknowledgeAlerts = (alerts) => {
	return () => {
		alertService.unAcknowledgeNotifications(alerts, (err) => {
			if (err) {
				console.log(err);
			}
		});
	};
};
